import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Kullanici} from '../model/kullanici';
import {RestService} from '../providers/rest.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-kullanici-liste',
  templateUrl: './kullanici-liste.component.html',
  styleUrls: ['./kullanici-liste.component.css']
})
export class KullaniciListeComponent implements OnInit {
  kullanicilar: Kullanici[] = null;

  @Output() updateKullanicilar = new EventEmitter<boolean>();
  showGrupInfoVal = false;
  showSubeInfoVal = false;

  @Input()
  public set source(kullanicilar: Kullanici[]) {
    if (kullanicilar != null) {
      this.kullanicilar = kullanicilar;
    }
  }

  @Input()
  public set showGrupInfo(val: boolean) {
    if (val != null) {
      this.showGrupInfoVal = val;
    }
  }

  @Input()
  public set showSubeInfo(val: boolean) {
    if (val != null) {
      this.showSubeInfoVal = val;
    }
  }

  constructor(private router: Router,
              private restService: RestService) {
  }

  ngOnInit(): void {
  }


  kaldir(s: Kullanici) {
    if (confirm(`${s.kullaniciAdi} kullanıcısını silmek istediğinize emin misiniz?`)) {
      this.restService.kullaniciSil(s.id).subscribe(res => {
        if (res) {
          this.updateKullanicilar.emit(true);
        }
      });
    }
  }

  incele(s: Kullanici) {
    this.router.navigate(['kullanici'], {queryParams: {id: s.id}});
  }

  showKullaniciGrupDetails(grupId: number) {
    this.router.navigate(['kullanici-grup'], {queryParams: {id: grupId}});
  }

  showSubeGrupDetails(subeId: number) {
    this.router.navigate(['sube'], {queryParams: {id: subeId}});
  }
}
